import { Component, OnInit } from '@angular/core';
import { RecipientMaintenanceFilterComponent } from './recipient-maintenance-filter/recipient-maintenance-filter.component';
import { RecipientMaintenanceService } from './recipient-maintenance.service';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { ConfirmDialogComponent } from 'src/app/services/dialog/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { catchError, finalize } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { MAINTENANCE_RECIPIENT_FOLDERNAME } from "src/app/utils/constant";
import * as _ from 'lodash';

@Component({
  selector: 'esc-recipient-maintenance',
  templateUrl: './recipient-maintenance.component.html',
  styleUrls: ['./recipient-maintenance.component.scss']
})

export class RecipientMaintenanceComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    types: false,
    export: false,
    import: false,
    error: false,
    detailError: false,
  }
  private listSub: Subscription;
  private detailSub: Subscription;
  private recipientTypesSub: Subscription;
  public folderName = MAINTENANCE_RECIPIENT_FOLDERNAME
  public listData = [];
  public detailData;
  public recipientTypes = [];
  public columns = ["fullname", "reference_code", "is_active"];
  public detailKeys = ["recipient_type", "fullname", "reference_code", "email_address", "contact_number", "max_registration", "is_active"];
  public excelCols = ["RECIPIENT TYPE CODE", "FULL NAME", "REFERENCE CODE", "EMAIL ADDRESS", "CONTACT NUMBER", "STATUS"]
  private currentFilters;
  private previousFilters;
  public listLength = 0;
  public mode;
  public modifying: Boolean = false;
  public deselect: Boolean = false;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    public media: MediaObserver,
    private recipientMntSvc: RecipientMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private helper: HelperService
  ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.getListData();
    this.getListRecipientTypes();
  }

  download(ev) {
    let dialogRef = this.dialogService.loading();
    this.listSub = this.recipientMntSvc.genericMaintenanceDownload(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }

  /* Not called anymore for version 2.1.0 */
  qrBulkDownload(event) {
    let dialogRef = this.dialogService.loading();
    let reqObj = {
      web_filter: {
        keyword: this.currentFilters.web_filter.keyword,
        status: this.currentFilters.web_filter.status,
        filters: {
          web_user_id: this.currentFilters.web_filter.filters.web_user_id
        }
      },
      data: {}
    }
    this.recipientMntSvc.bulkDownloadQR(reqObj).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.downloadThruEmailNotif();
          dialogRef.close();
        }
      });
  }

  /* Not called anymore for version 2.1.0 */
  couponBulkDownload(event) {
    let dialogRef = this.dialogService.loading();
    let reqObj = {
      web_filter: {
        keyword: this.currentFilters.web_filter.keyword,
        status: this.currentFilters.web_filter.status,
        filters: {
          web_user_id: this.currentFilters.web_filter.filters.web_user_id
        }
      },
      data: {
        folder_grouping_by: event
      }
    }
    this.recipientMntSvc.couponBulkDownloadQR(reqObj).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.downloadThruEmailNotif();
          dialogRef.close();
        }
      });
  }

  private downloadThruEmailNotif() {
    this.dialogService.openDialog(ConfirmDialogComponent, {
      width: "400px",
      autoFocus: true,
      disableClose: true,
      data: {
        title: this.languageService.getTranslation("LABEL_DOWNLOAD", {}),
        message: this.languageService.getTranslation("MSG_SUCCESS_QR_BULK_DOWNLOAD", {}),
        button: this.languageService.getTranslation("LABEL_OK", {}),
        hasCancel: false,
      }
    });
  }

  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }
    this.listSub = this.recipientMntSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.toNumber(_.get(res, "count"));
        }
      });
  }

  getListRecipientTypes() {
    if (this.recipientTypesSub && !this.recipientTypesSub.closed) {
      this.recipientTypesSub.unsubscribe();
    }
    if (this.loading.types == true) {
      return;
    }
    this.loading.error = false;
    if (this.recipientTypes.length == 0) {
      this.loading.types = true;
    }
    this.recipientTypesSub = this.recipientMntSvc.getListTypes().pipe(
      finalize(() => {
        this.loading.types = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.recipientTypes.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.recipientTypes = [];
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.recipientTypes = this.recipientTypes.concat(res.data);
        }
      });
  }

  getMore(event) {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    if (event) {
      this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
      this.getListData();
    }
  }

  getDetail(data) {
    if(data) {
      let temp = this.listData.filter(e => {
        return e.id == data.id;
      })
      this.detailData = _.clone(temp[0]);
      this.deselect = false;
    }
  }

  addNew(event) {
    this.closeDetail(null);
    this.modifying = true;
    this.mode = 'Add';
  }

  edit(event) {
    this.modifying = true;
  }

  searchBy(keyword) {
    this.currentFilters.web_filter.keyword = _.clone(keyword);
    this.refresh(true);
  }

  openFilter(ev) {
    let dialogRef: MatDialogRef<RecipientMaintenanceFilterComponent>;
    dialogRef = this.dialogService.openDialog(RecipientMaintenanceFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        // Save filters to be used when user opens modal again
        this.previousFilters = _.cloneDeep(selectedFilters);
      
        // Set values from filters
        let selectedWebUsers = _.get(selectedFilters, 'webuser');
        this.currentFilters.web_filter.filters.web_user_id = _.map(selectedWebUsers, val => val.id);
        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');

        this.refresh(null);
      }
    })
  }

  saving(event) {
    this.loading.detail = true;
    if(_.has(event[0], 'code')) {
      let obj = _.get(event, '[0]');
      this.detailData = _.clone(obj);
    } 
    else if(!event) {
      this.loading.detail = false;
    }
  }

  closeDetail(event) {
    this.detailData = null;
    this.deselect = true;
  }

  closeForm(event) {
    this.modifying = false;
    this.mode = null;
    if(event) {
      this.refresh(event);
    }
  }

  refresh(event) {
    if (!event) {
      this.closeDetail(null);
    }
    this.listData = [];
    this.recipientTypes = []
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(INITIAL_OPTIONS.web_filter.offset);
    this.getListData();
    this.getListRecipientTypes();
  }

  downloadQR(event) {
    let dialogRef = this.dialogService.loading();
    this.recipientMntSvc.downloadQR({ code: this.detailData.code }).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    limit: 50,
    offset: 0,
    keyword: "",
    is_asc: 1,
    status: null,
    is_dropdown: 0,
    filters: {
      web_user_id: [0]
    }
  }
};